/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useMemo, useLayoutEffect, useEffect } from "react";
import objectPath from "object-path";
import { useLocation } from "react-router-dom";
import { QuickActions } from "./components/QuickActions";
import { BreadCrumbs } from "./components/BreadCrumbs";
import {
  getBreadcrumbsAndTitle,
  useSubheader,
} from "../../_core/MetronicSubheader";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { useQuery, useQueryClient } from "react-query";
import { GetMenus } from "../../../../app/services/security.service";
import { getJwtToken } from "../../../../app/services/auth.service";
export function SubHeader() {
  
  const uiService = useHtmlClassService();
  const location = useLocation();
  const subheader = useSubheader();

  const layoutProps = useMemo(() => {
    return {
      config: uiService.config,
      subheaderMobileToggle: objectPath.get(
        uiService.config,
        "subheader.mobile-toggle"
      ),
      subheaderCssClasses: uiService.getClasses("subheader", true),

      subheaderContainerCssClasses: uiService.getClasses(
        "subheader_container",
        true
      ),
    };
  }, [uiService]);
  let { data: sideMenu, isLoading: sideMenuLoading } = useQuery(
    "GetSideMenus",
    () => {
      return GetMenus();
    },
    { enabled: getJwtToken() != null }
  );
  let pathTree = [
    {
      id: 2,
      title: "کارتابل",
      name: "loan",
      icon: "ManageSearchIcon",
      route: "#",
      parentId: null,
      menuMapRoute: "کارتابل",
      subMenus: [
        {
          id: 5,
          title: " تسویه با پذیرنده",
          name: "SupplierSettlementCartable",
          icon: "ListAltIcon",
          route: "/loan/SupplierSettlementCartable",
          parentId: 2,
          menuMapRoute: "کارتابل .  تسویه با پذیرنده",
          subMenus: [],
        },
        {
          id: 6,
          title: "  ثبت نام توسط مشتری",
          name: "CustomerRegistration",
          icon: "ListAltIcon",
          route: "/loan/CustomerRegistration",
          parentId: 2,
          menuMapRoute: "کارتابل .  ثبت نام توسط مشتری",
          subMenus: [],
        },
        {
          id: 6,
          title: "  ثبت نام توسط پذیرنده",
          name: "LoanRegistrationBySupplier",
          icon: "ListAltIcon",
          route: "/loan/LoanRegistrationBySupplier",
          parentId: 2,
          menuMapRoute: "کارتابل .   ثبت نام توسط پذیرنده",
          subMenus: [],
        },
        {
          id: 6,
          title: "  امور پذیرندگان",
          name: "SupplierRequirements",
          icon: "ListAltIcon",
          route: "/loan/SupplierRequirements",
          parentId: 2,
          menuMapRoute: "کارتابل .   امور پذیرندگان",
          subMenus: [],
        },
      ],
    },
  ];

  if (sideMenu) {
    pathTree = pathTree.concat(sideMenu);
  }
  // let m_sideMenu = flattenObject(pathTree); //for flat nested object
  function flattenObject(obj) {
    let result = {};
    for (const i in obj) {
      if (
        typeof obj[i] == "object"
        // && !Array.isArray(obj[i])
      ) {
        const temp = flattenObject(obj[i]);
        for (const j in temp) {
          result[i + "." + j] = temp[j];
        }
      } else {
        result[i] = obj[i];
      }
    }
    return result;
  }

  useLayoutEffect(() => {
    const aside = getBreadcrumbsAndTitle(
      "kt_aside_menu",
      location.pathname,
      // m_sideMenu,
      pathTree
    );
    // const header = getBreadcrumbsAndTitle("kt_header_menu", location.pathname);
    // const breadcrumbs = (aside && aside.breadcrumbs.length > 0) ? aside.breadcrumbs : header.breadcrumbs;
    // subheader.setBreadcrumbs(breadcrumbs);
    subheader.setBreadcrumbs(aside.breadcrumbs);
    //subheader.setTitle((aside && aside.title && aside.title.length > 0) ? aside.title : header.title);
    // eslint-disable-next-line

  }, [location.pathname, sideMenuLoading]);

  // Do not remove this useEffect, need from update title/breadcrumbs outside (from the page)
  useEffect(() => {

  }, [subheader]);


  return (
    <div
      id="kt_subheader"
      className={` Toastify__toast-body subheader-override subheader py-2 py-lg-4   ${layoutProps.subheaderCssClasses}`}
      style={{ backgroundColor: "c1c7cb" }}
    >
      <div
        className={`${layoutProps.subheaderContainerCssClasses} d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap`}
      >
        {/* Info */}
        <div className="d-flex align-items-center flex-wrap mr-1">
          {layoutProps.subheaderMobileToggle && (
            <button
              className="burger-icon burger-icon-left mr-4 d-inline-block d-lg-none"
              id="kt_subheader_mobile_toggle"
            >
              <span />
            </button>
          )}

          <div className="d-flex align-items-baseline mr-5">
            <h5 className="text-dark font-weight-bold my-2 mr-5">
              <>{subheader.title}</>
              {/*<small></small>*/}
            </h5>
          </div>

          <BreadCrumbs items={(subheader.breadcrumbs != null && subheader.breadcrumbs.length > 0) ? subheader.breadcrumbs : (localStorage.getItem("BIHeaderTitle") != null && localStorage.getItem("BIHeaderTitle") != "") ? [JSON.parse(localStorage.getItem("BIHeaderTitle"))] : ""} />
        </div>

        {/* Toolbar */}
        <div className="d-flex align-items-center"></div>
      </div>
    </div>
  );
}
